<script setup lang="ts">
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
import { onBeforeMount, ref, computed } from 'vue'
import { useLandMakeStore } from '@/stores/useLandMakeStore'

const nuxtApp = useNuxtApp()
const { nuxt2Context }: any = nuxtApp
const { localePath } = nuxt2Context

const props = defineProps({
  hasRedirectButton: {
    type: Boolean,
    required: false,
    default: true,
  },
})

const landMakeMyInfo = computed(() => useLandMakeStore().getLandMakeInfo)

onBeforeMount(async () => {
  await useLandMakeStore().fetchLandMakeInfo()
})

// Computed
const isBeating = computed(() => {
  const leftValue = landMakeMyInfo.value.totalVolume - landMakeMyInfo.value.occupiedVolume
  return leftValue <= 2 && landMakeMyInfo.value.totalVolume <= 10
})
</script>

<template>
  <div v-if="landMakeMyInfo" class="w-full h-12">
    <div
      class="text-center border border-solid border-bfh-border rounded text-bfh-text-light font-bold bg-bfh-sub p-2 w-64 text-sm float-right"
    >
      <span> {{ $t('land.landMake.residueVolume') }}：</span>
      <span v-if="!!Object.keys(landMakeMyInfo).length">
        {{ landMakeMyInfo.totalVolume - landMakeMyInfo.occupiedVolume }}
        / {{ landMakeMyInfo.totalVolume }}</span
      >
      <nuxt-link v-if="hasRedirectButton" :to="localePath('market-index-shop-index-landvolumeshop')">
        <fa-icon :icon="['fas', 'plus-circle']" :class="{ 'fa-beat': isBeating }" style="color:#FFA800" size="lg" />
      </nuxt-link>
    </div>
  </div>
</template>
